import Alpine from "alpinejs";

// Alpine Plugins
// ==============================================
import history from "./plugins/history";
Alpine.plugin(history);

// import intersect from '@alpinejs/intersect'
// Alpine.plugin(intersect)

import session from "./plugins/session";
Alpine.plugin(session);

// import persist from '@alpinejs/persist'
// Alpine.plugin(persist)

import focus from "@alpinejs/focus";
Alpine.plugin(focus);

// Alpine Stores
// ==============================================
import mobileMenu from "./stores/mobileMenu";
Alpine.store("mobileMenu", mobileMenu);

// Alpine Data
// ==============================================
// import listbox from './components/listbox'
// Alpine.data('listbox', listbox)

// import menu from './components/menu'
// Alpine.data('menu', menu)

import popover from "./components/popover";
Alpine.data("popover", popover);

import popovergroup from "./components/popovergroup";
Alpine.data("popovergroup", popovergroup);

// import radiogroup from './components/radiogroup'
// Alpine.data('radiogroup', radiogroup)

import shipdate from "./components/shipdate";
Alpine.data("shipdate", shipdate);

import variantselector from "./components/variantselector";
Alpine.data("variantselector", variantselector);

import validation from "./components/validation";
Alpine.data("validation", validation);

// Apps
// ==============================================
import locations from "./apps/locations";
Alpine.data("locations", locations);

Alpine.start();

// Swiper sliders
// ==============================================
import SwiperCore, { Swiper, Navigation, Keyboard } from "swiper/core";
SwiperCore.use([Navigation, Keyboard]);

document
	.querySelectorAll(".featured-collection-slider")
	.forEach((container) => {
		new Swiper(container.querySelector(".swiper-container"), {
			slidesPerView: 1.5,
			spaceBetween: 20,
			navigation: {
				nextEl: container.querySelector(".swiper-button-next"),
				prevEl: container.querySelector(".swiper-button-prev"),
			},
			keyboard: {
				enabled: true,
			},
			breakpoints: {
				640: {
					slidesPerView: 2.5,
				},
				768: {
					slidesPerView: 3,
					spaceBetween: 48,
				},
				1280: {
					slidesPerView: 4,
				},
			},
		});
	});
